// extracted by mini-css-extract-plugin
module.exports = {"section":"_2XMdO","marginSection":"_2Oq6L","image":"_3I_M-"};